import { Divider as DividerAntd, Row } from 'antd';
import { rgba } from 'polished';
import styled from 'styled-components';

import CoreButton from 'components/Buttons';
import { COLOR } from 'styles/styledComponents/color.model';

export const HeaderWrapper = styled.div`
  background-color: ${rgba(COLOR.IRON, 0.26)};
  margin: -90px;
  padding: 90px;
  padding-bottom: 0;
  margin-bottom: 0;
`;

export const Overall = styled.span`
  margin-bottom: 50px;
  line-height: 15px;
  font-size: 12px;
  font-weight: bold;
`;

export const Title = styled.h1`
  margin-bottom: 50px;
  text-transform: uppercase;
  font-weight: bold;
  line-height: 22px;
  font-size: 18px;
`;

export const AdditionalComments = styled.div`
  font-weight: bold;
  margin-bottom: 10px;
  position: relative;
`;

export const Divider = styled(DividerAntd)`
  margin-top: 50px;
`;

export const ButtonRow = styled(Row)`
  margin-top: 20px;
`;

export const Button = styled(CoreButton)`
  &:not(:last-of-type) {
    margin-right: 20px;
  }
`;
